<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner">
        <contentVideo :url="videourl" :img="videoimg"></contentVideo>
      </div>
      <div class="main2-content">
        <contentTabs :index="5"></contentTabs>
        <contentLeft :list="list[0]"></contentLeft>
        <div class="divHeight"></div>
        <contentRight :list="list[1]"></contentRight>
        <div class="divHeight"></div>
        <contentLeft :list="list[2]"></contentLeft>
        <div class="divHeight"></div>
        <contentRight :list="list[3]"></contentRight>
        <div style="height: 100px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentVideo from "./contentVideo.vue";
import contentTabs from "./contentTabs.vue";
import contentLeft from "./contentLeft.vue";
import contentRight from "./contentRight.vue";
export default {
  components: {
    contentVideo,
    contentTabs,
    contentLeft,
    contentRight
  },
  data() {
    return config.workshop5;
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
  background-image: url("../../assets/meb/imgs/CYbg@2x.png");
  background-size: 100% 100%;
  background-repeat-x: no-repeat;
}
.divHeight {
  height: 23px;
}
</style>
